// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ScheduledMaintenanceStatusDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class ScheduledMaintenanceStatusApiClient extends BaseCRUDApiClient<ScheduledMaintenanceStatusDto> {
  baseUrl = this.config.apiEndpoint + '/scheduled-maintenance-status';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
